// extracted by mini-css-extract-plugin
module.exports = {"switch":"Toggle_switch__3rNe8","slider":"Toggle_slider__1uefF","container":"Toggle_container__1rYLj","round":"Toggle_round__1VFrn"};